"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
// eslint-disable-next-line import/no-cycle
const index_1 = require("../index");
const GoogleButtonWeb_1 = __importDefault(require("./GoogleButtonWeb"));
const GoogleButtonMobile_1 = __importDefault(require("./GoogleButtonMobile"));
const GoogleAuth = ({ onSuccess, onError, buttonConfig, locale, clientId, navigation, featureFlags, customButtonConfig, scope, trackingId, }) => {
    const defaultFeatureFlags = {
        googleButton: true,
        googleOneTap: true,
    };
    const cleanFeatureFlags = Object.assign(defaultFeatureFlags, featureFlags);
    const { client_type: clientType } = navigation;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [clientType === index_1.ClientType.WEB && ((0, jsx_runtime_1.jsx)(GoogleButtonWeb_1.default, { onSuccess: onSuccess, onError: onError, buttonConfig: buttonConfig, locale: locale, clientId: clientId, navigation: navigation, featureFlags: cleanFeatureFlags, scope: scope, trackingId: trackingId })), clientType === index_1.ClientType.MOBILE && ((0, jsx_runtime_1.jsx)(GoogleButtonMobile_1.default, { ...customButtonConfig,
                navigation,
                onSuccess,
                onError }))] }));
};
exports.default = GoogleAuth;
